export function isFromInput(event: KeyboardEvent | React.KeyboardEvent) {
  return (
    (event.target instanceof HTMLElement && event.target.isContentEditable) ||
    event.target instanceof HTMLInputElement ||
    event.target instanceof HTMLTextAreaElement ||
    event.target instanceof HTMLSelectElement
  );
}
